import React from "react";
// import { Link } from "react-router-dom";
import { Link } from "../pages/Home/Home";
import "../components/links.css";
const NavBar = () => {
  return (
    <div
      style={{
        minHeight: "3.25rem",
        display: "flex",
        alignItems: "stretch",
        borderBottom: "solid 1px #444444",
        paddingBottom: "10px",
        width: "90%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: "1.75rem",
        }}
        className="underline_on_hover"
      >
        Shreyas
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "20px",
        }}
      >
        <span className="underline_on_hover link">
          <Link to={"/bookshelf"}>Bookshelf</Link>
        </span>
        {/* <span className="underline_on_hover link">
          <Link to={"/articles"}>Articles</Link>
        </span>
        <span className="underline_on_hover link">
          <Link to={"/bookshelf"}>Papershelf</Link>
        </span> */}
      </div>
    </div>
  );
};

export default NavBar;
